<template>
  <div class="mask">
    <div class="box">
      <div class="flex">
        <p class="title mb-3">提交待办成功</p>
        <p class="content mb-3">后期可在公众号我的待办列表中查看待办进度</p>
        <button class="info" @click="handleFinish">确定</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "SubmitSuccessConfirm",
    methods:{
      handleFinish(){
        this.$emit('finish');
      }
    }
  }
</script>

<style scoped>
  .flex{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding:141px 23px 23px 23px;
    background: url('../assets/r1.png');
    background-size: cover;
    border-radius: 9px;
  }
  .title{
    font-weight: bold;
    font-size: 20px;
  }
  .content{
    font-size: 16px;
    color: #999999;
    text-align: center;
  }
</style>